<div class="main-content">
  <div class="main-container">
    <ov-suite-hierarchy-table
      [title]="'Inventory Levels by SKU and Held By User'"
      [formClass]="formClass"
      [hasBulkUpload]="false"
      [excludeColumns]="4"
      [hideAddButton]="true"
      [filter]="filter"
      [enableRefresh]="true"
    >
    </ov-suite-hierarchy-table>
  </div>
</div>
